// Sai Maheshwar 11/11/2022 3031689933  integrated locked process
import React, {useState, useRef, useEffect, useContext} from 'react';
import IdleTimer from 'react-idle-timer';
import DialogExpiry from '../util/ExpiryDialog';
import {useHistory} from 'react-router-dom';
import {fetchToken} from '../redux/reducers/RefreshToken';
import {useDispatch, useSelector} from 'react-redux';
import SelectTabContextProvider from '../components/SelectTabContext/SelectTabContext';
import {releaseLockedProcess} from './Rest';

export default function IdleTimerContainer() {
  const {setExpiryMsg} = useContext(SelectTabContextProvider);
  const history = useHistory();
  const dispatch = useDispatch();
  const {newToken} = useSelector(({refreshToken}) => refreshToken);
  useEffect(() => {
    if (newToken?.token) {
      sessionStorage.setItem('token', newToken.token);
    }
  }, [newToken]);
  //   const { isLoggedIn } = useContext(SelectTabContextProvider);
  const [open, setOpen] = useState(false);
  const idleTimerRef = useRef(null);
  const sessionTimeOutRef = useRef(null);
  const logOut = () => {
    releaseLockedProcess();
    sessionStorage.clear();
    history.push('/login');
    setOpen(false);
    setExpiryMsg('Session Expired!');
    clearTimeout(sessionTimeOutRef.current);
  };

  const onIdle = () => {
    setOpen(true);
    sessionTimeOutRef.current = setTimeout(logOut, 5 * 60 * 1000);
  };
  const staySignedIn = () => {
    dispatch(fetchToken());
    setOpen(false);
    clearTimeout(sessionTimeOutRef.current);
  };
  return (
    <div>
      <DialogExpiry open={open} logOut={logOut} staySignedIn={staySignedIn} />
      <IdleTimer ref={idleTimerRef} timeout={25 * 60 * 1000} onIdle={onIdle}></IdleTimer>
    </div>
  );
}
